import Qs from 'qs';
import { AxiosRequestConfig } from 'axios';
import { v3 } from '@adobe/edex/frontend/api/v3';

export function search(options: Partial<AxiosRequestConfig>) {
  return v3.get('/search', {
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'repeat' });
    },
    ...options,
  });
}
